export default __webpack_public_path__ + "media/waiting-room-discover.af2e67cf.webp";